module.exports = __webpack_public_path__ + "static/media/included3.da97ecee.svg";